// Re-export notification utilities for easier imports
export { toast, confirm, alert } from '@/components/ui/Toaster';